@let currentPipeline = currentPipeline$ | async;
@if (loading$ | async) {
  <glxy-loading-spinner [fullHeight]="true" [size]="'large'"></glxy-loading-spinner>
} @else {
  @if (currentPipeline?.id) {
    <div class="pipeline-forms" [formGroup]="pipelineForm">
      <glxy-form-field [bottomSpacing]="false">
        <glxy-label>{{ 'PIPELINES.SETTINGS.FORM.TITLES.PIPELINE_NAME' | translate }}</glxy-label>
        <input
          type="text"
          formControlName="name"
          placeholder="{{ 'PIPELINES.SETTINGS.FORM.PLACEHOLDER.PIPELINE_NAME' | translate }}"
          matInput
        />
      </glxy-form-field>
      <div class="pipeline-stage-form-title-group">
        <div class="pipeline-stage-form-title">
          {{ 'PIPELINES.SETTINGS.FORM.TITLES.PIPELINE_NAME' | translate }}
        </div>
        <div class="pipeline-stage-form-subtitle">
          {{ 'PIPELINES.SETTINGS.FORM.SUBTITLES.PIPELINE_STAGES' | translate }}
        </div>
      </div>
      <mat-card>
        <div class="pipeline-stages-header">
          <div class="row">
            <div class="col col-sm-8 pipeline-stages-content">
              {{ 'PIPELINES.SETTINGS.FORM.TITLES.STAGE_NAME' | translate }}
            </div>
            <div class="col col-sm-4 pipeline-stages-content">
              {{ 'PIPELINES.SETTINGS.FORM.TITLES.CLOSE_PROBABILITY' | translate }}
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <mat-card-content>
          @for (stageForm of stages.controls; track stageForm; let i = $index, last = $last) {
            @let status = stageForm.get('status')?.value;
            @let readonly = status !== 'Open';
            <div class="row pipeline-stages-form-group" [formGroup]="stageForm">
              <div class="col col-sm-8 pipeline-stages-content">
                <glxy-form-field [bottomSpacing]="last ? false : 'small'">
                  <input
                    type="text"
                    formControlName="name"
                    placeholder="{{ 'PIPELINES.SETTINGS.FORM.TITLES.STAGE_NAME' | translate }}"
                    [ngClass]="{
                      'closed-won-input': status === 'Closed Won',
                      'closed-lost-input': status === 'Closed Lost',
                    }"
                    matInput
                  />
                </glxy-form-field>
              </div>
              <div class="col col-sm-4 pipeline-stages-content">
                <div class="close-probability">
                  <glxy-form-field
                    [showLabel]="false"
                    [bottomSpacing]="last ? false : 'small'"
                    [suffixText]="'%'"
                    class="probability-input"
                  >
                    @if (readonly) {
                      <input
                        type="number"
                        formControlName="probability"
                        class="disabled"
                        [ngClass]="{
                          'closed-won-input': status === 'Closed Won',
                          'closed-lost-input': status === 'Closed Lost',
                        }"
                        matInput
                      />
                    } @else {
                      <input
                        type="number"
                        formControlName="probability"
                        min="1"
                        max="99"
                        step="1"
                        (keypress)="keyIsInteger($event)"
                        matInput
                      />
                    }
                  </glxy-form-field>
                  @if (readonly) {
                    <button mat-icon-button type="button" disabled></button>
                  } @else {
                    <button mat-icon-button type="button" (click)="deleteDisplayStage(i)">
                      <mat-icon class="pipeline-stages-button">close</mat-icon>
                    </button>
                  }
                </div>
              </div>
            </div>
            @if (!last) {
              <mat-divider></mat-divider>
            }
          }
        </mat-card-content>
        <mat-card-actions>
          <button mat-button type="button" color="primary" class="pipeline-stages-content" (click)="addStage()">
            + {{ 'PIPELINES.SETTINGS.CTA.ADD_STAGE' | translate }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <glxy-sticky-footer>
      <glxy-button-loading-indicator [isLoading]="savingChanges$$ | async">
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="saveChanges(currentPipeline?.id)"
          [disabled]="(pendingChanges$$ | async) === false"
        >
          {{ 'ACTIONS.SAVE' | translate }}
        </button>
      </glxy-button-loading-indicator>
      <button mat-stroked-button (click)="cancel()" [disabled]="(pendingChanges$$ | async) === false">
        {{ 'ACTIONS.CANCEL' | translate }}
      </button>
      <glxy-sticky-footer-secondary>
        <button mat-stroked-button color="warn" type="button" (click)="delete(currentPipeline?.id)">
          {{ 'ACTIONS.DELETE' | translate }}
        </button>
      </glxy-sticky-footer-secondary>
    </glxy-sticky-footer>
  }
}
